import { useState } from 'react';
import { Link } from 'react-router-dom';
import abimg from '../../images/about/ab2.png';

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const About4 = ({ settings }) => {
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  // state to track the main displayed image
  const [mainImage, setMainImage] = useState(
    settings.images && settings.images.length > 0 ? settings.images[0] : null
  );

  return (
    <section 
        className="wpo-about-section-s4 section-padding pb-120"
        style={{
            marginTop: "20px"
        }}
    >
      <div className="container">
        <div className="wpo-about-inner">
          <div className="row align-items-center justify-content-center">
            {/* Text Section */}
            <div className="col-xl-5 col-lg-6 col-md-12 col-12">
              <div className="wpo-about-text">
                <h4>STAR FAMILY INDUSTRIAL PLC</h4>
                <h2
                    style={{
                        color: "darkblue"
                    }}
                >We are trusted Import - Export Industrial PLC.</h2>
                <p
                  style={{
                    textAlign: 'justify',
                    fontSize: '15px',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: settings.who_we_are
                  }}
                />
                <div className="text-sub-wrap">
                  <div className="text-sub-item">
                    <i className="fi flaticon-tax"></i>
                    <h5
                      style={{
                        textAlign: 'justify',
                        fontSize: '16px',
                      }}
                    >
                      Our core business areas include the export of coffee, oil
                      seeds, live animals, and spices, as well as importing and
                      distributing tyres and engaging in real estate
                      development, farming, and mineral production.
                    </h5>
                  </div>
                </div>
                <Link onClick={ClickHandler} className="theme-btn" to="/service">
                  Our Services
                </Link>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-xl-7 col-lg-6 col-md-12 col-12">
              {settings.images && settings.images.length > 0 ? (
                <div className="wpo-about-wrap">
                  <div className="wpo-about-img">
                    <div
                      className="inner-img"
                      style={{
                        overflow: 'visible',
                        textAlign: 'center',
                        position: 'relative',
                      }}
                    >
                      {/* Main Image */}
                      <div
                        style={{
                          position: 'relative',
                          display: 'inline-block',
                        }}
                      >
                        <img
                          src={`${apiUrl}/storage/${mainImage}`}
                          alt="About"
                          style={{
                            width: '610px',
                            height: '350px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            marginBottom: '50px',
                            boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                          }}
                        />
                      </div>

                      {/* Thumbnails */}
                      <div
                        style={{
                          display: 'flex',
                          gap: '10px',
                          flexWrap: 'wrap',
                          justifyContent: 'center',
                        }}
                      >
                        {settings.images.map((img, index) => (
                          <img
                            key={index}
                            src={`${apiUrl}/storage/${img}`}
                            alt={`about-${index}`}
                            onClick={() => setMainImage(img)}
                            style={{
                              width: '90px',
                              height: '90px',
                              objectFit: 'cover',
                              borderRadius: '5px',
                              border:
                                mainImage === img
                                  ? '2px solid darkblue'
                                  : '1px solid #ddd',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease',
                              boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Fallback if no images
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={abimg}
                    alt="About fallback"
                    style={{
                      width: '610px',
                      height: '350px',
                      objectFit: 'contain',
                      borderRadius: '20px',
                      boxShadow: '0 10px 25px rgba(0, 0, 50, 0.4)',
                    }}
                  />
                  <div
                    style={{
                      position: 'relative',
                      top: '-120px',
                      width: '100%',
                      height: '35%',
                      background: 'linear-gradient(to top, rgba(0, 102, 204, 0.2), transparent)',
                      borderRadius: '0 0 20px 20px',
                    }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="shape-ab"></div>
    </section>
  );
};

export default About4;
